angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.synchronizationListController', ['$scope', 'platformWebApp.bladeUtils', 'platformWebApp.bladeNavigationService', 'platformWebApp.dialogService', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.uiGridHelper', 'platformWebApp.ui-grid.extension',
        function ($scope, bladeUtils, bladeNavigationService, dialogService, marketplaceApi, uiGridHelper, gridOptionExtension) {
            $scope.uiGridConstants = uiGridHelper.uiGridConstants;
            var blade = $scope.blade;
            blade.headIcon = 'fas fa-repeat';

            blade.refresh = function () {
                blade.isLoading = true;

                marketplaceApi.getSyncClients(function (data) {
                    $scope.listEntries = data;
                });

                blade.isLoading = false;
            };

            blade.runSyncFromGrid = function () {
                let selectedRows = $scope.gridApi.selection.getSelectedRows();
                let activeSyncTypes = selectedRows.filter(x => x.isActive).map(x => x.typeName);

                runSync(activeSyncTypes);
            };

            blade.toolbarCommands = [
                {
                    name: "platform.commands.refresh",
                    icon: 'fa fa-refresh',
                    executeMethod: blade.refresh,
                    canExecuteMethod: function () {
                        return true;
                    }
                },
                {
                    name: "marketplace.commands.synchronization",
                    icon: 'fa fa-repeat',
                    executeMethod: blade.runSyncFromGrid,
                    canExecuteMethod: isAnyItemsChecked
                }
            ];

            function isAnyItemsChecked() {
                if ($scope.gridApi && $scope.gridApi.selection) {
                    let selectedRows = $scope.gridApi.selection.getSelectedRows();
                    if (selectedRows.length > 0) {
                        return true;
                    }
                }
                return false;
            }

            function runSync(items) {
                marketplaceApi.syncRun({ clientTypes: items }, function (data) {
                    var newBlade = {
                        title: 'marketplace.blades.synchronization-details.title',
                        icon: 'fa fa-repeat',
                        notification: data,
                        controller: 'virtoCommerce.marketplaceModule.synchronizationDetailsController',
                        template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/synchronization-details.tpl.html'
                    };
                    bladeNavigationService.showBlade(newBlade, blade);
                });
            }

            $scope.selectNode = function (listItem) {
            //    $scope.selectedNodeTypeName = listItem.typeName;
            //    $scope.showDetails(listItem);
            }

            $scope.canRunSyncForItem = function (listItem) {
                if (listItem && listItem.isActive) {
                    return true;
                }
                return false;
            };

            $scope.syncRunFromMenu = function (listItem) {
                if (listItem.isActive) {
                    runSync([listItem.typeName]);
                }
            }

            $scope.setGridOptions = function (gridId, gridOptions) {
                $scope.gridOptions = gridOptions;
                gridOptionExtension.tryExtendGridOptions(gridId, gridOptions);

                gridOptions.onRegisterApi = function (gridApi) {
                    $scope.gridApi = gridApi;
                    gridApi.core.on.sortChanged($scope, function () {
                        if (!blade.isLoading) blade.refresh();
                    });
                };

                bladeUtils.initializePagination($scope);
            };

        }
    ]);
